const message = {
	home: 'Inicio',
	aboutUs: 'Sobre Nosotros',
	areas: 'Áreas',
	news: 'Novedades',
	newDetails: 'Novedades',
	contactUs: 'Contáctanos',
	aboutIncocegla: 'Sobre INCOCEGLA',
	ourFacilities: 'Nuestras <br>Instalaciones',
	glaucomaClub: 'Club del<br> Glaucoma',
	incoceglaFoundation: 'Fundación<br> INCOCEGLA',
	medicalEquipment: 'Equipo Médico',
	patients: 'Pacientes',
	press: 'Prensa',
	doctorsAndDepartments: 'Doctores y <br>departamentos',
	otherAreas: 'Otras <br>especialidades',
	medicalInsurance: 'Seguro Médicos',
	arsAffiliates: 'ARS Afiliados',
	pathologiesMoreConsulted: 'Patologías más<br> consultadas',
	faq: 'Peguntas frecuentes',
	visionTest: 'Test de visión'
};

export default message;
